import deepClone from 'lodash/cloneDeep'

export function toFiltered<T>(array: readonly T[], predicate: (item: T) => boolean): T[] {
  return deepClone(array.filter(predicate))
}
